export const videoDialogDragDirective = {
  bind(el) {
    let odiv = el;   //获取当前元素
    let pdiv = odiv.parentElement;
    odiv.onmousedown = (e) => {
      //算出鼠标相对元素的位置
      let sX = e.clientX;
      let sY = e.clientY;

      pdiv = odiv.parentElement;
      let oX = parseInt(pdiv.style.left);
      let oY = parseInt(pdiv.style.top);
      document.onmousemove = (e) => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - sX;
        let top = e.clientY - sY;
        //移动当前元素
        pdiv.style.left = (oX + left) + 'px';
        pdiv.style.top = (oY + top) + 'px';
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
};
